import React, { Component } from 'react';
import classes from "./Chart_Zodiac_Board.module.css";
import Chart_Zodiac_RadarChart2 from './Chart_Zodiac_RadarChart2';
/* 
<p>The Zodiac Furniture Collection can be created using Gold, Stone, Star and Zodiac fragments that fall from the sky. The chart shows the number of materials needed to create each item. (Click names in the Legend to toggle.)</p>
*/
export default class Chart_Zodiac_Board2 extends Component {

    render() {
        return (
            <div className={classes.container}>
                <h4>Zodiac: Fire Sign</h4>
                <Chart_Zodiac_RadarChart2 />    
            </div>
        )
    }
}

/* Tutorial from:
     https://code.tutsplus.com/tutorials/getting-started-with-chartjs-radar-and-polar-area-charts--cms-28444 
*/